import { render, staticRenderFns } from "./ModalCreateCategory.vue?vue&type=template&id=d50d28e8"
import script from "./ModalCreateCategory.vue?vue&type=script&lang=js"
export * from "./ModalCreateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports